import React, { useContext, useEffect } from 'react'
import HeadingBanner from '../Components/HeadingBanner.jsx'
import Schemes from '../Components/Schemes.jsx'
import { RazarDetails } from '../context/razarApi.js'

export default function Sceme({setopenScheme , setting_datas}) {


  // const {n} = useContext(RazarDetails)


  return (
    <>
     <HeadingBanner title={"GreenHeap Scheme"} />
     <Schemes setopenSchemes={setopenScheme} setting_data={setting_datas}  />
    </>
  )
}
